import React from 'react';
import { FaPrint, FaPalette, FaTruck, FaShieldAlt, FaRedoAlt, FaDraftingCompass } from 'react-icons/fa';
import './Service.css';
import TrustedBy from './TrustedBy';
import EmergencyService from './EmergencyService';

const services = [
  {
    icon: <FaPrint />,
    title: 'Top Quality Prints',
    description: 'We provide high-quality, professional prints designed to meet the demands of your business.',
  },
  {
    icon: <FaPalette />,
    title: 'Mix and match colors',
    description: 'Explore various finishes, colors, and styles for your business cards with premium print quality.',
  },
  {
    icon: <FaDraftingCompass />,
    title: 'Design & Branding',
    description: 'Build a unique brand identity with our custom design and branding services tailored to your needs.',
  },
  {
    icon: <FaTruck />,
    title: 'Shipping worldwide',
    description: 'Enjoy our advanced 3D printing services, and we’ll ship your products to any location globally.',
  },
  {
    icon: <FaShieldAlt />,
    title: 'Quality Guarantee',
    description: 'We stand by the quality of our custom-printed mugs, ensuring they’re perfect for both corporate and personal use.',
  },
  {
    icon: <FaRedoAlt />,
    title: 'Reorder quickly',
    description: 'Easily reorder your custom-printed T-shirts with high-quality materials, ensuring consistency every time.',
  },
];

const Service = () => {
  return (
    <div className="service-section">
      <div className="about-hero">
        <div className="hero-overlay">
          <h1 className="hero-heading">Adcore Consulting</h1>
          <p className="hero-subheading">Your trusted partner for Printing innovation and top-quality printing services.</p>
          
        </div>
      </div>
      <h2 className="section-title">Professional Digital Printing</h2>
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <div className='service-icon'>{service.icon}</div>
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
      <TrustedBy/>
      <EmergencyService/>
    </div>
  );
};

export default Service;
